// @flow @format
import React, {PureComponent, type Node} from 'react';
import Popover from '../Popover';
import classNames from 'lib/classnames';
import './Modal.css';

type Props = {
	visible: boolean,
	onClose: () => void,
	children?: Node,
};

class Modal extends PureComponent<Props> {
	render() {
		const {visible, children, onClose} = this.props;
		return (
			<Popover>
				<section
					className={classNames({
						ModalOverlay: true,
						'ModalOverlay--Active': visible,
						'theme-light': true,
					})}
				>
					<div onClick={onClose} className="ModalOverlay__Backdrop" />
					<div className="Modal">
						{visible && children}
					</div>
				</section>
			</Popover>
		);
	}
}

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.js